var _path, _path2, _path3, _rect, _path4, _rect2, _path5, _circle, _circle2, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.594 101.414c-12.672 9.8-30.951 8.888-42.576-2.738-12.573-12.572-12.616-32.93-.128-45.556H37.43a6.63 6.63 0 0 0-6.36 5.47L18 122.32h89.671l-15.288-15.288a4.002 4.002 0 0 1-.384-5.213l-.405-.405Zm33.943 18.629L137.88 59.88a5.478 5.478 0 0 0-5.09-6.76H94.83c11.71 11.84 12.402 30.477 2.075 43.12l.336.336a4.002 4.002 0 0 1 5.214.384l23.082 23.083Z",
    fill: "#E9AF34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m49.018 98.676-.265.266.265-.266Zm42.576 2.738.265-.265a.375.375 0 0 0-.495-.031l.23.296ZM48.89 53.12l.267.264a.375.375 0 0 0-.267-.64v.376Zm-11.46 0v-.375h-.01l.01.375Zm-4.155 1.601.244.285-.244-.285ZM31.07 58.59l.367.075.002-.01-.369-.065ZM18 122.32l-.367-.075a.374.374 0 0 0 .367.45v-.375Zm89.671 0v.375a.373.373 0 0 0 .346-.232.373.373 0 0 0-.081-.408l-.265.265Zm-15.288-15.288.265-.265-.265.265Zm-.384-5.213.3.224a.375.375 0 0 0-.035-.489l-.265.265Zm45.881-41.94-.365-.087-.002.013.367.075Zm-12.343 60.164-.265.265a.376.376 0 0 0 .633-.19l-.368-.075Zm7.253-66.923.016-.375h-.016v.375Zm-37.96 0v-.375a.375.375 0 0 0-.267.639l.267-.264Zm2.075 43.12-.29-.237a.375.375 0 0 0 .025.503l.265-.266Zm.336.336-.265.266c.132.131.34.146.49.035l-.225-.3Zm5.214.384.265-.265-.265.265Zm-53.702 1.982c11.76 11.76 30.251 12.683 43.07 2.769l-.459-.593c-12.524 9.685-30.591 8.783-42.081-2.707l-.53.53Zm-.13-46.086c-12.632 12.772-12.59 33.367.13 46.086l.53-.53c-12.427-12.428-12.469-32.55-.126-45.028l-.533-.528Zm-11.193.639h11.46v-.75H37.43v.75Zm-3.91 1.51a6.256 6.256 0 0 1 3.92-1.51l-.02-.75a7.004 7.004 0 0 0-4.39 1.692l.49.569Zm-2.08 3.65a6.255 6.255 0 0 1 2.08-3.65l-.49-.568a7.004 7.004 0 0 0-2.33 4.087l.74.131Zm-13.073 63.74 13.07-63.73-.734-.15-13.07 63.73.734.15Zm89.304-.45H18v.75h89.671v-.75Zm-15.553-14.648 15.288 15.288.53-.53-15.288-15.288-.53.53Zm-.42-5.701a4.376 4.376 0 0 0 .42 5.701l.53-.53a3.627 3.627 0 0 1-.349-4.724l-.601-.447Zm-.37.083.405.406.53-.531-.404-.405-.53.53Zm46.185-41.874-12.343 60.162.735.151 12.342-60.163-.734-.15Zm.039-2.246a5.1 5.1 0 0 1-.037 2.233l.73.176a5.87 5.87 0 0 0 .041-2.561l-.734.152Zm-.921-2.035a5.11 5.11 0 0 1 .921 2.035l.734-.152a5.849 5.849 0 0 0-1.056-2.334l-.599.451Zm-1.701-1.447a5.09 5.09 0 0 1 1.701 1.447l.599-.451a5.855 5.855 0 0 0-1.951-1.66l-.349.664Zm-2.156-.582a5.104 5.104 0 0 1 2.156.582l.349-.664a5.853 5.853 0 0 0-2.473-.668l-.032.75Zm-37.944 0h37.96v-.75H94.83v.75Zm2.366 42.983c10.446-12.791 9.747-31.645-2.1-43.622l-.533.528c11.574 11.701 12.258 30.123 2.052 42.62l.58.474Zm.31-.167-.335-.336-.53.53.335.337.53-.53Zm5.214.384a4.376 4.376 0 0 0-5.703-.42l.448.602a3.626 3.626 0 0 1 4.724.348l.531-.53Zm23.082 23.083L102.72 96.695l-.531.53 23.083 23.083.53-.53Z",
    fill: "#E9AF34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 122.32V27.68h30.3l5.86 10.26h64a4.63 4.63 0 0 1 4.63 4.63v6.75",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 99.622,
    y: 96.982,
    width: 40.121,
    height: 10.243,
    rx: 2,
    transform: "rotate(45 99.622 96.982)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m93.586 95.775 3.622 3.622-2.415 2.415-3.621-3.622z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 99.622,
    y: 96.982,
    width: 40.121,
    height: 10.243,
    rx: 2,
    transform: "rotate(45 99.622 96.982)",
    fill: "#DB6C2F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#DB6C2F",
    d: "m93.586 95.775 3.622 3.622-2.415 2.415-3.621-3.622z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71.856,
    cy: 75.856,
    r: 29.929,
    transform: "rotate(45 71.856 75.856)",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.856,
    cy: 75.856,
    r: 23.166,
    transform: "rotate(45 71.856 75.856)",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.111 65.887a19.069 19.069 0 0 0-16.519-9.097",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderSearch);
export default __webpack_public_path__ + "static/media/folder_search.4e7d24f79d7be9aec9744702ea06fdf7.svg";
export { ForwardRef as ReactComponent };